import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import loginimg from "../images/logo.jpg";
import { setToken } from "./Auth.js";
import figuraemail from "../images/email.png";
import senha from "../images/password.png";
import "../css/styles.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const login = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await axios.post("/api/login", {
        email,
        password,
      });

      if (res.data.Status === "Success") {
        setToken(res.data.Token);
        localStorage.setItem("UserRole", res.data.Role || "user");
        localStorage.setItem(
          "UserSecretariaId",
          res.data.User.id_secretaria || ""
        );
        localStorage.setItem("UserName", res.data.User.name);

        localStorage.setItem("UserId", res.data.User.id || "");
        navigate("/");
        window.location.reload();
      } else {
        setError(res.data.Error || "Erro no login");
      }
    } catch (err) {
      console.error("Erro no login:", err);
      setError("Erro ao tentar fazer login");
    }
  };

  return (
    <div className="container-principal">
      <form className="containerdashboardlogin" onSubmit={login}>
        <div className="col-12">
          <p
            style={{
              fontSize: "1.75rem",
              fontWeight: "bold",
              color: "#2c3e50",
              borderBottom: "3px solid rgb(172, 187, 197)",
              paddingBottom: "10px",
              display: "inline-block",
            }}
          >
            PREFEITURA MUNICIPAL DE GUARATINGUETÁ
          </p>
          <div
            className="logologin"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img src={loginimg} alt="Logo" className="img-fluid" />
          </div>

          <h1
            className="m-0"
            style={{
              fontSize: "1.75rem",
              fontWeight: "bold",
              color: "#2c3e50",
              borderBottom: "3px solid rgb(162, 201, 226)",
              paddingBottom: "10px",
              textAlign: "center",
            }}
          >
            Login Administrativo
          </h1>

          {error && (
            <h1
              style={{
                color: "red",
                fontSize: "20px",
                textAlign: "center",
                marginTop: "20px",
              }}
            >
              {error}
            </h1>
          )}

          <img width="40" height="40" src={figuraemail} alt="email icon" />
          <div>
            <input
              type="email"
              className="input-containerlogin"
              placeholder="Email do administrador"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <img width="40" height="40" src={senha} alt="password icon" />
          <div>
            <input
              type="password"
              className="input-containerlogin"
              placeholder="Senha do administrador"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="submit-button">
            Entrar
          </button>

          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => navigate("/")}
            >
              Voltar para Home
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Login;
